import { Route, Routes } from 'react-router';
import Enum from '../../enum';
import List from './List';
import ById from './ById';

const TravelsComponent = ({ ...props }) => {
  // <div>{'TravelsComponent'}</div>
  return (
    <Routes>
      <Route path={`/`} element={<List { ...props } />} />
      <Route path={`/:course`} element={<ById { ...props } />} />
    </Routes>
  );
};

export default TravelsComponent;
